import { Store } from 'vuex'
import { emitter } from '@kwixeo/interface-vue'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.MailModelCreated',
    callback: (model: KwixeoCommunication.Model): void => {
      store.dispatch('communication/setModel', model)
    }
  },
  {
    name: '.MailModelUpdated',
    callback: (model: KwixeoCommunication.Model): void => {
      store.dispatch('communication/setModel', model)
    }
  },
  {
    name: '.MailModelDeleted',
    callback: (model: KwixeoCommunication.Model): void => {
      store.dispatch('communication/deleteModel', model)
    }
  },

  {
    name: '.SenderCreated',
    callback: (sender: KwixeoCommunication.Sender): void => {
      store.dispatch('communication/setSender', sender)
    }
  },
  {
    name: '.SenderUpdated',
    callback: (sender: KwixeoCommunication.Sender): void => {
      store.dispatch('communication/setSender', sender)
    }
  },
  {
    name: '.SenderDeleted',
    callback: (sender: KwixeoCommunication.Sender): void => {
      store.dispatch('communication/deleteSender', sender)
    }
  },

  {
    name: '.ReportCreated',
    callback: (report: KwixeoCommunication.Report): void => {
      emitter.emit('reportCreated', report)
    }
  },
  {
    name: '.ReportUpdated',
    callback: (report: KwixeoCommunication.Report): void => {
      emitter.emit('reportUpdated', { new: report, old: null })
    }
  },
  {
    name: '.ReportDeleted',
    callback: (report: KwixeoCommunication.Report): void => {
      emitter.emit('reportDeleted', report)
    }
  },

  {
    name: '.LetterCreated',
    callback: (letter: KwixeoCommunication.Letter): void => {
      emitter.emit('letterCreated', letter)
    }
  },
  {
    name: '.LetterUpdated',
    callback: (letter: KwixeoCommunication.Letter): void => {
      emitter.emit('letterUpdated', { new: letter, old: null })
    }
  },
  {
    name: '.LetterDeleted',
    callback: (letter: KwixeoCommunication.Letter): void => {
      emitter.emit('letterDeleted', letter)
    }
  },

  {
    name: '.MailSent',
    callback: (event: KwixeoCommunication.MailSentEvent): void => {
      emitter.emit('mailSent', event)
    }
  },
  {
    name: '.MailAttachmentsLoaded',
    callback: (event: KwixeoCommunication.MailAttachmentsLoadedEvent): void => {
      emitter.emit('mailAttachmentsLoaded', event)
    }
  }

])
